import { CSSProperties, useMemo } from "react";

import { Icon } from "semantic-ui-react";

import DisplayFileSize from "./DisplayFileSize";

type DisplayContentFileProps = {
  content?: string | null;
  file: File | string;
  showFileSize?: boolean;
};

type Styles = Record<"fileBox" | "fileImage", CSSProperties>;

const styles: Styles = {
  fileBox: {
    alignItems: "center",
    display: "flex",
  },
  fileImage: {
    alignItems: "center",
    display: "flex",
    height: "33px",
    width: "33px",
  },
};

const allowedExtRegex = /\.(png|jpg|jpeg|gif|webp|pdf|xlsx|xls|doc|docx)$/i;

export const getContentFileName = (content?: string | null) => {
  if (content) {
    const fileMatch = /^file::.*\.\w+$/i.exec(content);
    const imageMatch = /^image::.*\.\w+$/i.exec(content);
    const fileTypeMatch = allowedExtRegex.test(content);

    if (fileMatch || imageMatch || fileTypeMatch) {
      return content.replaceAll(/file::|image::/g, "");
    }
  }

  return "";
};

const DisplayContentFile = (props: DisplayContentFileProps) => {
  const name = useMemo(
    (): string => (props.file instanceof File ? props.file.name : props.file),
    [props.file],
  );

  const fileName = useMemo(() => {
    const formattedName = decodeURI(name.split("?")[0].split("/").pop() || "");

    let finalFileName = formattedName;
    if (getContentFileName(props.content?.name || props.content) !== "") {
      finalFileName = getContentFileName(props.content?.name || props.content);
    } else if (props.content) {
      const extFromFormatted = formattedName.match(/\.[a-z0-9]+$/i)?.[0] || "";
      finalFileName = (props.content?.name || props.content) + extFromFormatted;
    }

    return finalFileName;
  }, [name, props.content]);

  return (
    <div className="file">
      <div style={styles.fileBox}>
        <div className="file-image" style={styles.fileImage}>
          <Icon style={{ height: "unset" }} name="file alternate" size="big" />
        </div>
        <div>
          <div
            className="text"
            style={{ padding: "0 0 0 5px", textAlign: "start" }}
            data-file-name={fileName}
          >
            {fileName || "Click to open file"}
          </div>
          {props.showFileSize && <DisplayFileSize file={props.file} />}
        </div>
      </div>
    </div>
  );
};

export default DisplayContentFile;
